import apiHelper from "./apiHelper";
import axios, { AxiosResponse } from "axios";
import { getApiInformation } from "../helpers/apiHelper";

export const rootUrl = process.env.REACT_APP_PAYMENT_URL;
export const commonRootUrl = "https://tahsilat.elogo.com.tr";

/**
 * 23.02.2026 Apisauce replacement
 */
const api = axios.create({
  baseURL: rootUrl,
  validateStatus: () => true, // apisauce gibi hata fırlatmaz
});

/**
 * Apisauce response.ok taklidi
 */
api.interceptors.response.use(
  (response: AxiosResponse) => {
    return {
      ...response,
      ok: response.status >= 200 && response.status < 300,
    } as any;
  },
  (error) => {
    if (error.response) {
      return Promise.resolve({
        ...error.response,
        ok: false,
      });
    }

    return Promise.resolve({
      ok: false,
      status: 0,
      data: null,
    });
  }
);

type apiParams = {
  licenseKey: string,
  taxCode: string,
  passLicenseControl?: boolean
};

const paymentApi = {

  get: async function (method: string, params: any, apiParams: apiParams) {

    const licenseKey = apiParams?.licenseKey;
    const taxCode = apiParams?.taxCode;
    const { apiKey, apiSecret } = getApiInformation();

    let headerAuth = "";

    if (apiParams?.passLicenseControl) {
      headerAuth = btoa(apiKey + ":" + apiSecret);
    } else {
      headerAuth = btoa(apiKey + ":" + apiSecret + ":" + licenseKey + ":" + taxCode);
    }

    const response: any = await api.get(method, {
      params: params,
      headers: {
        Authorization: `basic ${headerAuth}`
      }
    });

    if (response.ok) {
      return apiHelper.apiSuccess({ result: response, passControl: true });
    } else {
      return apiHelper.apiError({ errorMsg: response.data });
    }
  },

  post: async function (method: string, params: any, apiParams: apiParams) {

    const licenseKey = apiParams?.licenseKey;
    const taxCode = apiParams?.taxCode;
    const { apiKey, apiSecret } = getApiInformation();

    let headerAuth = "";

    if (apiParams?.passLicenseControl) {
      headerAuth = btoa(apiKey + ":" + apiSecret);
    } else {
      headerAuth = btoa(apiKey + ":" + apiSecret + ":" + licenseKey + ":" + taxCode);
    }

    const response: any = await api.post(method, params, {
      headers: {
        Authorization: `basic ${headerAuth}`,
        "Content-Type": "application/json; charset=utf-8",
        Accept: "application/json"
      }
    });

    if (response.ok) {
      return apiHelper.apiSuccess({
        result: response,
        passControl: true
      });
    } else {
      return apiHelper.apiError({ errorMsg: response.data });
    }
  }
};

export default paymentApi;